/**
 * Auto-generated by packages/engine-ts/bench/run.ts — do not hand-edit.
 *
 * To regenerate:
 *   npm run bench --workspace=packages/engine-ts
 *
 * This data file is imported by the live Home + About pages so the
 * "validated" badge stays in lockstep with the benchmark. If you change
 * the benchmark numbers here by hand, the next CI run will overwrite them.
 */

export interface BenchmarkSummary {
  readonly version: "v1";
  readonly generatedAt: string;
  readonly embedder: string;
  readonly queryCount: number;
  readonly matchCount: number;
  readonly metrics: {
    readonly ndcgAt5: number;
    readonly ndcgAt10: number;
    readonly precisionAt1: number;
    readonly precisionAt3: number;
    readonly precisionAt5: number;
    readonly mrr: number;
    readonly spearman: number;
    readonly verdictAccuracy?: number;
  };
  readonly perQuery: ReadonlyArray<{
    readonly id: string;
    readonly label: string;
    readonly ndcgAt5: number;
    readonly precisionAt1: number;
    readonly reciprocalRank: number;
  }>;
  readonly floor: number;
  readonly baselineReportUrl: string;
  readonly datasetUrl: string;
}

export const BENCHMARK_SUMMARY: BenchmarkSummary = {
  version: "v1",
  generatedAt: "2026-04-09T23:14:05.917Z",
  embedder: "bench-bow-v1",
  queryCount: 8,
  matchCount: 32,
  metrics: {
    ndcgAt5: 0.9872,
    ndcgAt10: 0.9872,
    precisionAt1: 1.0000,
    precisionAt3: 0.4167,
    precisionAt5: 0.3438,
    mrr: 1.0000,
    spearman: 0.7312,
    verdictAccuracy: 0.6563,
  },
  perQuery: [
  {
    id: "query_backend",
    label: "Senior Backend Engineer — Payments Platform",
    ndcgAt5: 0.9738,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_clinical",
    label: "Senior Clinical Data Scientist — Mercia Health AI",
    ndcgAt5: 1.0000,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_design",
    label: "Senior Product Designer at a B2B SaaS company",
    ndcgAt5: 1.0000,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_finance",
    label: "Senior Financial Analyst at a fintech company",
    ndcgAt5: 0.9738,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_marketing",
    label: "Head of Growth Marketing at a DTC brand",
    ndcgAt5: 1.0000,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_ml",
    label: "Senior ML Engineer — Recommendations",
    ndcgAt5: 0.9500,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_operations",
    label: "Head of Operations at a Series B SaaS startup",
    ndcgAt5: 1.0000,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  {
    id: "query_sales",
    label: "Enterprise SaaS Account Executive",
    ndcgAt5: 1.0000,
    precisionAt1: 1.0000,
    reciprocalRank: 1.0000,
  },
  ],
  floor: 0.65,
  baselineReportUrl:
    "https://github.com/aousabdo/talent_align/blob/main/data/benchmark/v1/baseline.md",
  datasetUrl:
    "https://github.com/aousabdo/talent_align/tree/main/data/benchmark/v1",
};
